<app-layout size="100%">
  <app-breadcrumb [breadcrumbItems]="[
  { label: ('breadcrumb.login' | translate), link: '/' },
  { label: ('breadcrumb.resetPassword' | translate) }
]"></app-breadcrumb>
  <div class="change-password-container">
    <div class="form-section">
      <app-title title="updatePassword.header" />
      <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">

        <app-input [label]="'updatePassword.currentPassword' | translate" [formGroup]="passwordForm"
          name="currentPassword" type="password" [required]="true"></app-input>

        <div class="forgot-password-link">
          <a routerLink="/forgot-password" queryParamsHandling="preserve" class="btn btn-secondary">
            {{ 'updatePassword.forgotPassword' | translate }}</a>
        </div>

        <app-input [label]="'updatePassword.newPassword' | translate" [formGroup]="passwordForm" name="newPassword"
          type="password" [required]="true" (input)="checkPassword()"></app-input>

        <app-input [label]="'updatePassword.confirmPassword' | translate" [formGroup]="passwordForm"
          name="confirmPassword" type="password" [required]="true"></app-input>

        @if (passwordMismatch) {
        <div class="error">
          {{ 'updatePassword.passwordMismatch' | translate}}
        </div>
        }

        @if (wrongPasswordError) {
        <div class="error">
          {{ 'updatePassword.wrongPasswordError' | translate}}
        </div>
        }

        @if (apiError) {
        <div class="error">
          @if (apiError.translationKey) {
          {{ apiError.translationKey | translate }}
          } @else {
          {{ apiError.rawMessage }}
          }
        </div>
        }

        @if (success) {
        <div id="password-change-success" class="success">
          {{ 'updatePassword.success' | translate}}
          <a routerLink="/" queryParamsHandling="preserve" class="goBack">{{ 'updatePassword.clickHere' |
            translate}}</a>
        </div>
        }

        <div class="button-group">
          @if (submitting) {
          <app-spinner></app-spinner>
          } @else {
          <app-button variant="primary">
            <button type="submit" data-testid="update-password-submit"
              [disabled]="!passwordForm.valid || passwordMismatch || button_clicked">{{
              'updatePassword.changePasswordInput' | translate }}</button>
          </app-button>
          }

          <app-button variant="secondary">
            <a routerLink="/continue" queryParamsHandling="preserve" class="btn btn-secondary" type="button">{{
              'updatePassword.cancel' | translate }}</a>
          </app-button>
        </div>
      </form>
    </div>

    <div class="requirements-section">
      <div class="requirements">
        <h4>{{ 'updatePassword.requirementsHeader' | translate}}</h4>
        <ul>
          <li [class.valid]="validations.minLength">{{
            'updatePassword.requirement1' | translate}}</li>
          <li [class.valid]="validations.uppercase">{{
            'updatePassword.requirement2' | translate}}</li>
          <li [class.valid]="validations.number">{{
            'updatePassword.requirement3' | translate}}</li>
          <li [class.valid]="validations.specialChar">{{
            'updatePassword.requirement4' | translate}}</li>
        </ul>
      </div>
    </div>

  </div>
</app-layout>